import { useState, useEffect, useRef } from "react";

const videos = [
  { id: "eB9dHsbpezk", si: "9ROyMq6PAyv6K3l_", title: "Ahead of the curve with Nikunj Duggal | MG ZS EV" },
  { id: "h8-1A33rDsk", si: "KNzB1F-Ls35y0eeJ", title: "Spreading Smiles with Dr. Jitesh Sehgal | MG ZS EV" },
  { id: "BzNsoKtlLc4", si: "xuaOhztxffB0bOkZ", title: "#StoriesOfMG | MG ZS EV | MG Abhimanyu" },
  { id: "MGMTm6mQicQ", si: "QY9i2vrhjq80ryX1", title: "#StoriesOfMG | MG ZS EV | Gaurav Rathod" },
  { id: "1YqCAOB_mCE", si: "D_sxTlJ1ihqud1xK", title: "#StoriesOfMG | MG ZS EV | Surendra Roy" },
  { id: "W90c55u88Ks", si: "a2J-CAiF-54m_K3c", title: "#StoriesOfMG | MG ZS EV | Karma Butia" },
  { id: "cX2_dDy0JJs", si: "EZ5o3dsyiaj7DmST", title: "#StoriesOfMG | MG ZS EV | Vinayanad" },
  { id: "A93z-ios0gk", si: "SmNjkGjmvOqG-ne4", title: "#StoriesOfMG | MG ZS EV | Adarsh Benakappa Basavaraj" },
  { id: "4dX2nBj6uIo", si: "SF2nCcfg-9qwt_jE", title: "#StoriesOfMG | MG ZS EV | Dr. S. Sreekumar" },
  { id: "eZASn9GDyWA", si: "I67yJLVyk36Vjega", title: "#StoriesOfMG | Prasad Joshi | MG ZS EV" },
];

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .ct-section {
    font-family: 'Open Sans', Arial, sans-serif;
    background: #fff;
    padding: 40px 0 48px;
    overflow: hidden;
  }

  .ct-page-title {
    text-align: center;
    font-size: clamp(1.2rem, 4vw, 1.75rem);
    font-weight: 700;
    color: #CF2230;
    margin-bottom: 28px;
    padding: 0 16px;
  }

  .ct-main-container {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
  }

  .ct-inner-container {
    overflow: hidden;
    width: 100%;
  }

  .ct-stage {
    display: flex;
    transition: transform 0.4s ease;
    will-change: transform;
  }

  .ct-item {
    flex-shrink: 0;
    background: #fff;
  }

  .ct-img {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    background: #000;
    border-radius: 4px;
  }
  .ct-img iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  .ct-title-desc-container {
    padding: 8px 0 4px;
  }
  .ct-item-desc {
    font-size: 0.85rem;
    color: #333;
    font-weight: 400;
    line-height: 1.45;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: 'Open Sans', Arial, sans-serif;
  }

  .ct-owl-nav {
    display: flex;
    justify-content: center;
    gap: 4px;
    margin-top: 24px;
  }

  .ct-owl-prev,
  .ct-owl-next {
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    background: #CF2230;
    border: none;
    cursor: pointer;
    color: #fff;
    font-size: 1.6rem;
    line-height: 1;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
    border-radius: 2px;
    padding: 0;
    user-select: none;
  }
  .ct-owl-prev:hover,
  .ct-owl-next:hover { background: #a01a25; }

  .ct-owl-prev:disabled,
  .ct-owl-next:disabled {
    background: #d4d4d4;
    cursor: default;
  }
`;

export default function CustomerTestimonials() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(2);
  const [itemW, setItemW] = useState(0);
  const containerRef = useRef(null);
  const GAP = 15;

  useEffect(() => {
    if (!containerRef.current) return;
    const update = () => {
      const w = containerRef.current.offsetWidth;
      // Max 2 cards on all screen sizes; 1 on mobile
      const v = w >= 560 ? 2 : 1;
      setVisible(v);
      setItemW((w - GAP * (v - 1)) / v);
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  useEffect(() => { setIndex(0); }, [visible]);

  const maxIndex = Math.max(0, videos.length - visible);
  const translateX = index * (itemW + GAP);

  const prev = () => setIndex((i) => Math.max(0, i - 1));
  const next = () => setIndex((i) => Math.min(maxIndex, i + 1));

  return (
    <>
      <style>{css}</style>
      <div className="ct-section">
        <h2 className="ct-page-title">Customer Testimonials</h2>

        <div className="ct-main-container">
          <div className="ct-inner-container" ref={containerRef}>
            <div
              className="ct-stage"
              style={{
                transform: `translateX(-${translateX}px)`,
                gap: `${GAP}px`,
              }}
            >
              {videos.map((v, i) => (
                <div
                  className="ct-item"
                  key={i}
                  style={{ width: itemW || "auto", flex: `0 0 ${itemW ? itemW + "px" : "auto"}` }}
                >
                  <div className="ct-img">
                    <iframe
                      src={`https://www.youtube.com/embed/${v.id}?si=${v.si}`}
                      title={v.title}
                      allowFullScreen
                    />
                  </div>
                  <div className="ct-title-desc-container">
                    <div className="ct-item-desc">{v.title}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="ct-owl-nav">
            <button className="ct-owl-prev" onClick={prev} disabled={index === 0} aria-label="Previous">
              ‹
            </button>
            <button className="ct-owl-next" onClick={next} disabled={index >= maxIndex} aria-label="Next">
              ›
            </button>
          </div>
        </div>
      </div>
    </>
  );
}